<template>
  <div class="header">
    <div class="header-left" @click="resetCountEvent">
      <img class="logo" src="../assets/images/logo-dragonpass@2x.png" />
      <img class="sub-logo" src="../assets/images/logo-HIS@2x.png" />
    </div>
    <div class="header-right">
      <div class="box currency-box" @click.stop="showCurrencyBox">
        <span v-text="currency"></span>
        <img class="arrow-down" src="../assets/images/icon-arrow-language-currency@2x.png" alt />
        <ul class="select-box" v-show="currencyBox">
          <li
            v-for="(item, index) in currencyList"
            :key="item.name"
            @click="selectCurrency(item.name, index)"
          >
            <strong v-text="item.name"></strong>
            <span v-text="item.label"></span>
            <img
              class="selected"
              src="../assets/images/icon-language-tick@2x.png"
              v-show="index == currencyActive"
              alt
            />
          </li>
          <img class="triangle" src="../assets/images/triangle.png" alt />
        </ul>
      </div>
      <div class="box language-box" @click.stop="showLanguageBox">
        <img class="icon" :src="languageIcon" alt />
        <img class="arrow-down" src="../assets/images/icon-arrow-language-currency@2x.png" alt />
        <ul class="select-box" v-show="languageBox">
          <li
            v-for="(item, index) in languageList"
            :key="item.name"
            @click="selectLanguage(item.name, index)"
          >
            <strong>
              <img :src="item.imgSrc" alt />
            </strong>
            <span v-text="item.label"></span>
            <img
              class="selected"
              src="../assets/images/icon-language-tick@2x.png"
              v-show="index == languageActive"
              alt
            />
          </li>
          <img class="triangle" src="../assets/images/triangle.png" alt />
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ["reload"],
  name: "top",
  data() {
    return {
      currencyBox: false,
      languageBox: false,
      languageList: [
        {
          imgSrc: require("../assets/images/icon-english@2x.png"),
          label: "English(UK)",
          name: "en",
          selected: false
        },
        {
          imgSrc: require("../assets/images/icon-japan@2x.png"),
          label: "日本語",
          name: "ja",
          selected: true
        }
      ],
      currencyList: [
        {
          name: "USD",
          label: "US Dollar",
          selected: false
        },
        {
          name: "JPY",
          label: "Japanese Yen",
          selected: true
        }
      ]
    };
  },
  created() {
    document.onclick = () => {
      this.$set(this.$data, "currencyBox", false);
      this.$set(this.$data, "languageBox", false);
    };

    switch (this.language) {
      case "en":
        this.$i18n.locale = "en";
        break;
      case "ja":
        this.$i18n.locale = "ja";
    }

    console.log(`语言：${this.$i18n.locale}`);
  },
  methods: {
    showCurrencyBox() {
      this.currencyBox = !this.currencyBox;
      this.languageBox = false;
    },
    showLanguageBox() {
      this.languageBox = !this.languageBox;
      this.currencyBox = false;
    },
    selectLanguage(name, idx) {
      this.$store.commit("setLanguage", name);
      this.$store.commit("setLanguageIdx", idx);
      this.$store.commit("setLanguageIcon", this.languageList[idx].imgSrc);
      this.$store.commit("resetCount");
      this.$store.commit("resetTotalPrice", this.$store.state.price);
      this.reload();
    },
    selectCurrency(name, idx) {
      this.$store.commit("setCurrency", name);
      this.$store.commit("setCurrencyIdx", idx);
      this.getCurrency(name);
    },
    resetCountEvent() {
      this.$store.commit("resetCount");
      this.$store.commit("resetTotalPrice", this.$store.state.price);
      this.$router.push("/");
    },
    getCurrency(type) {
      this.$axios
        .post(
          "/api/auxiliary/getCurrencyPrice",
          {
            currencyType: type
          },
          {
            headers: {
              language: this.$i18n.locale,
              token: localStorage.getItem("pass")
            }
          }
        )
        .then(res => {
          if (res.data.state === "11") {
            this.$store.commit("setPrice", res.data.data);
            this.$store.commit("resetCount");
            this.$store.commit("resetTotalPrice", res.data.data);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  computed: {
    currency() {
      return this.$store.state.currency;
    },
    currencyActive() {
      return this.$store.state.currencyActive;
    },
    language() {
      return this.$store.state.language;
    },
    languageActive() {
      return this.$store.state.languageActive;
    },
    languageIcon() {
      return this.$store.state.languageIcon;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  height: 100px;
  background: #fff;
  position: relative;
}
.header-left {
  position: absolute;
  left: 5%;
  top: 33px;
  width: 310px;
  height: 34px;
  cursor: pointer;
}
.header-left .logo {
  width: 216px;
  height: 34px;
  position: absolute;
  left: 0;
  top: 0;
}
.header-left .sub-logo {
  width: 62px;
  height: 31px;
  position: absolute;
  left: 250px;
  top: 1px;
}
.header-right {
  position: absolute;
  right: 5%;
  font-size: 16px;
}
.header-right .box {
  height: 20px;
  line-height: 20px;
  position: absolute;
  top: 40px;
  cursor: pointer;
}
.header-right .currency-box {
  width: 60px;
  right: 80px;
}
.header-right .language-box {
  width: 54px;
  right: 0;
  font-size: 17px;
  font-weight: bold;
  line-height: 20px;
}
.arrow-down {
  width: 13.5px;
  height: 7.7px;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -3.85px;
}
.header-right .box .icon {
  width: 27.4px;
  height: 16px;
  position: absolute;
  left: 0;
  top: 3px;
}
.select-box {
  width: 240px;
  position: relative;
  border-radius: 4px;
  background: #fff;
  z-index: 9999;
  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.49);
}
.currency-box .select-box {
  right: 180px;
  top: 30px;
}
.language-box .select-box {
  right: 184px;
  top: 51px;
}
.language-box strong img {
  width: 27.4px;
  height: 16px;
}
.currency-box span {
  font-size: 17px;
  font-weight: bold;
}
.select-box .triangle {
  position: absolute;
  top: -16px;
  right: 30px;
}
.select-box li {
  height: 46px;
  line-height: 46px;
  cursor: pointer;
  position: relative;
}
.select-box li:first-child {
  border-bottom: 1px #ddd solid;
}
.select-box li strong {
  color: #910000;
  font-size: 14px;
  font-weight: bold;
  margin-left: 20px;
}
.select-box li span {
  color: #2d354c;
  font-size: 12px;
  position: absolute;
  left: 65px;
  top: -1px;
}
.select-box .selected {
  width: 20px;
  height: 18px;
  position: absolute;
  top: 12px;
  right: 8px;
}

@media screen and (max-width: 640px) {
  .header {
    width: 100%;
    height: 64px;
  }
  .header-left {
    left: 20px;
    top: 23px;
    width: 165px;
    height: 18px;
  }
  .header-left .logo {
    width: 120px;
    height: 18px;
  }
  .header-left .sub-logo {
    width: 35px;
    height: 18px;
    left: 130px;
  }
  .header-right {
    right: 20px;
  }
  .header-right .box {
    top: 21px;
    line-height: 18px;
  }
  .header-right .currency-box {
    width: 45px;
    right: 60px;
  }
  .header-right .language-box {
    width: 44px;
  }
  .currency-box span {
    font-size: 11px;
  }
  .header-right .box .icon {
    width: 20.5px;
    height: 12px;
  }
  .select-box {
    width: 200px;
  }
  .currency-box .select-box {
    right: 144px;
  }
  .language-box .select-box {
    right: 144px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue